var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-mb-6"},[_c('h1',[_vm._v("Data Extraction")]),_c('InputDETableCustom',{attrs:{"question":"What data will be extracted?","titleshort":_vm.$tera.project.nameShort},model:{value:(_vm.table),callback:function ($$v) {_vm.table=$$v},expression:"table"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }